import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames/bind';
import legacyEventHub, { cartItemsFromEvent } from '~/modules/legacyRuntime.js';

import Pagination from '~/components/legacy/Pagination.jsx';
import TrackBarebone from '~/components/legacy/TrackBarebone.jsx';
import Track from '~/components/legacy/Track.jsx';
import UsageLicenseTypeSelectSidebar from '~/components/legacy/UsageLicenseTypeSelectSidebar.jsx';
import { parseReactProps } from '~/components/legacy/reactProps.js';
import { requestJson } from '~/modules/legacyRequest.js';
import { sendTrackImpressionBatch } from '~/modules/catalogImpressionTracking.js';
import { currentMarketingTrackingPayload, currentUserTrackingContext, shouldTrackVisitorEvents } from '~/modules/catalogEventTracking.js';
import { translateLegacyText } from '~/modules/legacyI18n.js';
// import $ from 'jquery';

class TrackListing extends Component {

  constructor(props) {
    super(props);
    const initialCurrentQuery = this.buildInitialCurrentQuery(props);

    this.trackListing = null;

    this.setTrackListing = element => {
      this.trackListing = element;
    };

    this.pendingScrollTrigger = null;
    this.scrollFrameHandle = null;
    this.scrollRetryHandle = null;
    this.eventHubListeners = [];
    this.trackImpressionElements = new Map();
    this.trackImpressionObserver = null;
    this.trackImpressionTimers = new Map();
    this.trackVisibilityRatios = new Map();
    this.trackedImpressionKeys = new Set();
    this.pendingImpressions = [];
    this.impressionFlushTimeout = null;
    this.pageHideListener = this.handlePageHide.bind(this);
    this.visibilityChangeListener = this.handleVisibilityChange.bind(this);

    this.handleFavoriteClick = this.handleFavoriteClick.bind(this);
    this.handleCartClick = this.handleCartClick.bind(this);
    this.handleUsageLicenseTypeSelectClose = this.handleUsageLicenseTypeSelectClose.bind(this);
    this.handleFreeDownloadClick = this.handleFreeDownloadClick.bind(this);
    this.handlePaginationClick = this.handlePaginationClick.bind(this);
    this.handleEventHubPaginationClick = this.handleEventHubPaginationClick.bind(this);
    this.handleTrackImpressionIntersections = this.handleTrackImpressionIntersections.bind(this);
    this.getNameFor = this.getNameFor.bind(this);
    this.isActiveItem = this.isActiveItem.bind(this);

    this.state = {
      showUsageLicenseSelectForTrackId : [],
      showFreeDownloadDialogForTrackId : [],
      data : this.props.data,
      pagination : this.props.pagination,
      rankingContext: this.buildInitialRankingContext(props),
      searchQueryId: this.buildInitialSearchQueryId(props),
      active_track_id : this.props.active_track_id,
      cart_items: this.props.cart_items,
      currentQuery : initialCurrentQuery,
      trackFavorites : this.props.trackFavorites,

      searchInProgress : false,
      animationFinished : true,
      initialLoadPending: Array.isArray(this.props.data) && this.props.data.length === 0 && this.props.autoFetchOnMount === true
     };
  }

  buildInitialCurrentQuery(props) {
    const currentQueryFromPagination = this.currentQueryFromQueryString((props.pagination && props.pagination.current_query) || '');
    return this.normalizeCurrentQuery({ ...currentQueryFromPagination, ...(props.currentQuery || {}) }, props.initialNoFiltersActive);
  }

  normalizeOptionalInteger(value) {
    if (Number.isInteger(value)) {
      return value;
    }

    const parsedValue = parseInt(value, 10);
    return Number.isNaN(parsedValue) ? '' : parsedValue;
  }

  currentQueryFromQueryString(queryString = '') {
    const searchParams = new URLSearchParams(queryString || '');

    return {
      minLength: this.normalizeOptionalInteger(searchParams.get('min_length')),
      maxLength: this.normalizeOptionalInteger(searchParams.get('max_length')),
      loop: this.normalizeOptionalInteger(searchParams.get('loop'))
    };
  }

  normalizeCurrentQuery(currentQuery = {}, fallbackNoFiltersActive = this.props.initialNoFiltersActive) {
    const normalizedCurrentQuery = currentQuery || {};

    return {
      genres: Array.isArray(normalizedCurrentQuery.genres) ? normalizedCurrentQuery.genres : [],
      tags: Array.isArray(normalizedCurrentQuery.tags) ? normalizedCurrentQuery.tags : [],
      moods: Array.isArray(normalizedCurrentQuery.moods) ? normalizedCurrentQuery.moods : [],
      instoreTags: Array.isArray(normalizedCurrentQuery.instoreTags) ? normalizedCurrentQuery.instoreTags : [],
      minLength: this.normalizeOptionalInteger(normalizedCurrentQuery.minLength),
      maxLength: this.normalizeOptionalInteger(normalizedCurrentQuery.maxLength),
      loop: this.normalizeOptionalInteger(normalizedCurrentQuery.loop),
      includePro: typeof normalizedCurrentQuery.includePro === 'undefined' ? 2 : normalizedCurrentQuery.includePro,
      noFiltersActive: typeof normalizedCurrentQuery.noFiltersActive === 'undefined' ? fallbackNoFiltersActive : normalizedCurrentQuery.noFiltersActive
    };
  }

  buildInitialRankingContext(props) {
    return props.rankingContext || (props.pagination && props.pagination.ranking_context) || null;
  }

  buildInitialSearchQueryId(props) {
    return props.searchQueryId || (props.pagination && props.pagination.search_query_id) || null;
  }

  buildPageInstanceId() {
    let rankingContextKey = (this.state && this.state.rankingContext && this.state.rankingContext.ranking_context_key) || 'unknown';
    return [rankingContextKey, Date.now().toString(36)].join(':');
  }

  rankingTrackingPropsForTrack(track) {
    if (!track) {
      return {};
    }

    return {
      ranking_context_key: track.ranking_context_key,
      ranking_surface_type: track.ranking_surface_type,
      ranking_controller_name: track.ranking_controller_name,
      ranking_action_name: track.ranking_action_name,
      ranking_position: track.ranking_position,
      ranking_page_position: track.ranking_page_position,
      ranking_page: track.ranking_page,
      ranking_per_page: track.ranking_per_page,
      ranking_sort_by: track.ranking_sort_by,
      ranking_locale: track.ranking_locale,
      ranking_include_pro: track.ranking_include_pro,
      ranking_filters: track.ranking_filters,
      ranking_query: track.ranking_query,
      ranking_search_query_id: track.ranking_search_query_id,
      ranking_page_instance_id: this.pageInstanceId,
      is_exploration_lane: track.is_exploration_lane,
      exploration_reason: track.exploration_reason
    };
  }

  impressionRefForTrack(trackId) {
    return function(element) {
      if (element) {
        this.trackImpressionElements.set(trackId, element);
      } else {
        this.trackImpressionElements.delete(trackId);
      }
    }.bind(this);
  }

  impressionTrackingEnabled() {
    return !!(this.state.rankingContext && this.state.rankingContext.ranking_context_key && typeof IntersectionObserver !== 'undefined' && shouldTrackVisitorEvents());
  }

  getVisibleTracks(data = this.state.data) {
    const excludeTrackId = this.props.excludeTrackId;

    if (!excludeTrackId) {
      return Array.isArray(data) ? data : [];
    }

    return (Array.isArray(data) ? data : []).filter(function(track) {
      return track.id !== excludeTrackId;
    });
  }

  componentDidMount() {
    this.pageInstanceId = this.buildPageInstanceId();
    const initialTracks = this.getVisibleTracks(this.state.data);
    const shouldAutoFetchOnMount = initialTracks.length === 0 && this.props.autoFetchOnMount;

    if (initialTracks.length > 0 && !this.props.skipInitialPlayerInit) {
      const firstTrackId = initialTracks[0]?.id;

      if (firstTrackId) {
        legacyEventHub.trigger('playerInitTrack', firstTrackId);
      }
    } else if (!shouldAutoFetchOnMount) {
      setTimeout(function() {
        legacyEventHub.trigger('requestUpdateTrackListing');
      }, 10)
    }

    this.registerEventHubListener('updateTrackListing', function(data) {
      const payload = Array.isArray(data) ? data[0] : data;
      const tracks = Array.isArray(payload?.tracks) ? payload.tracks : [];
      const pagination = payload?.pagination || {};
      const shouldScroll = this.pendingScrollTrigger !== null;
      const scrollTrigger = this.pendingScrollTrigger;

      this.setState({
        data: tracks,
        pagination: pagination,
        rankingContext: payload?.ranking_context || pagination?.ranking_context || null,
        searchQueryId: payload?.search_query_id || pagination?.search_query_id || null
      }, function() {
        if (shouldScroll) {
          this.scheduleScrollToListStart(scrollTrigger);
        }

        this.pendingScrollTrigger = null;
        this.pageInstanceId = this.buildPageInstanceId();
        this.syncTrackImpressionObserver();
      }.bind(this));
    }.bind(this));

    this.registerEventHubListener('initialUpdateTrackListing', function(data) {
      const payload = Array.isArray(data) ? data[0] : data;
      const tracks = Array.isArray(payload?.tracks) ? payload.tracks : [];
      const pagination = payload?.pagination || {};

      this.setState({
        data: tracks,
        pagination: pagination,
        rankingContext: payload?.ranking_context || pagination?.ranking_context || null,
        searchQueryId: payload?.search_query_id || pagination?.search_query_id || null,
        initialLoadPending: false
      }, function() {
        this.pageInstanceId = this.buildPageInstanceId();
        this.syncTrackImpressionObserver();
      }.bind(this));

      const firstTrackId = this.getVisibleTracks(tracks)[0]?.id;
      if (firstTrackId && !this.props.skipInitialPlayerInit) {
        legacyEventHub.trigger('playerInitTrack', firstTrackId);
      }
    }.bind(this));

    this.registerEventHubListener('paginationClick', this.handleEventHubPaginationClick);

    this.registerEventHubListener('playTrack', function(data) {
        this.setState({active_track_id : data[0], activeTrackVariantId: ''})
    }.bind(this));

    this.registerEventHubListener('playTrackVariant', function(data) {
      this.setState({active_track_id : data[1], activeTrackVariantId: data[0]})
    }.bind(this));

    this.registerEventHubListener('playTrackVariantAtRatio', function(data) {
      const payload = Array.isArray(data) ? data[0] : data;
      if (!payload) {
        return;
      }

      this.setState({ active_track_id: payload.trackId, activeTrackVariantId: payload.trackVariantId });
    }.bind(this));

    this.registerEventHubListener('updateCart', function(data) {
        this.setState({cart_items: cartItemsFromEvent(data)});
    }.bind(this));

    this.registerEventHubListener('closePopupMenus', function() {
      this.setState({showUsageLicenseSelectForTrackId: [], showFreeDownloadDialogForTrackId: []})
    }.bind(this));

    this.registerEventHubListener('updateItemIdList', function(payload) {
      this.setState({currentQuery : this.normalizeCurrentQuery(payload[0]) });
    }.bind(this));

    this.registerEventHubListener('fireSearch', function() {
      this.setState({searchInProgress: true, animationFinished: false});
    }.bind(this));

    this.registerEventHubListener('fireSearchWithoutAnimation', function() {
      this.pendingScrollTrigger = null;
      this.setState({searchInProgress: false, animationFinished: true});
    }.bind(this));

    this.registerEventHubListener('searchSuccess', function() {
        setTimeout(function() {
            this.setState({searchInProgress: false});
        }.bind(this), 200);
        setTimeout(function() {
            this.setState({animationFinished: true});
        }.bind(this), 400);
    }.bind(this));

    this.registerEventHubListener('searchFailure', function() {
      this.pendingScrollTrigger = null;
      this.setState({searchInProgress: false, animationFinished: true});
    }.bind(this));

    this.registerEventHubListener('updateTrackFavorites', function(data) {
      this.setState({trackFavorites: data[0]});
    }.bind(this));

    if (shouldAutoFetchOnMount) {
      this.sendAjaxPaginationQuery(this.state.pagination.current_page || 1, { initialLoad: true }).catch(function(error) {
        console.warn('TrackListing initial load failed', error);
      });
    }

    document.addEventListener('visibilitychange', this.visibilityChangeListener);
    window.addEventListener('pagehide', this.pageHideListener);
    this.syncTrackImpressionObserver();
  }

  componentWillUnmount() {
    this.unregisterEventHubListeners();

    this.clearAllTrackImpressionTimers();
    this.flushPendingImpressions({ useBeacon: true });
    if (this.trackImpressionObserver) {
      this.trackImpressionObserver.disconnect();
      this.trackImpressionObserver = null;
    }
    if (this.impressionFlushTimeout) {
      window.clearTimeout(this.impressionFlushTimeout);
      this.impressionFlushTimeout = null;
    }
    document.removeEventListener('visibilitychange', this.visibilityChangeListener);
    window.removeEventListener('pagehide', this.pageHideListener);

    if (this.scrollFrameHandle !== null) {
      const cancelFrame = window.cancelAnimationFrame || window.clearTimeout;
      cancelFrame(this.scrollFrameHandle);
      this.scrollFrameHandle = null;
    }

    if (this.scrollRetryHandle !== null) {
      window.clearTimeout(this.scrollRetryHandle);
      this.scrollRetryHandle = null;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let previousRankingContextKey = prevState.rankingContext && prevState.rankingContext.ranking_context_key;
    let currentRankingContextKey = this.state.rankingContext && this.state.rankingContext.ranking_context_key;

    if (prevState.data !== this.state.data || previousRankingContextKey !== currentRankingContextKey) {
      this.syncTrackImpressionObserver();
    }
  }

  registerEventHubListener(eventName, handler) {
    legacyEventHub.on(eventName, handler);
    this.eventHubListeners.push({ eventName: eventName, handler: handler });
  }

  unregisterEventHubListeners() {
    if (!legacyEventHub || typeof legacyEventHub.off !== 'function') {
      this.eventHubListeners = [];
      return;
    }

    this.eventHubListeners.forEach(function(listener) {
      legacyEventHub.off(listener.eventName, listener.handler);
    });
    this.eventHubListeners = [];
  }

  handleFavoriteClick(trackId) {
    return requestJson("/track_favorite?track_id=" + trackId, {
      method: 'POST',
      data: {}
    }).then(function(data) {
        const trackData = this.state.data.find(function(track) {
          return track.id === trackId;
        });

        if (!(this.trackIsFavorited(trackId, this.state.trackFavorites))) {
            legacyEventHub.trigger('trackFavorited', Object.assign({ track_id: trackId }, this.rankingTrackingPropsForTrack(trackData)));
        }

        legacyEventHub.trigger('updateTrackFavorites', data)
    }.bind(this));
  }

  ensureTrackImpressionObserver() {
    if (this.trackImpressionObserver || !this.impressionTrackingEnabled()) {
      return;
    }

    this.trackImpressionObserver = new IntersectionObserver(this.handleTrackImpressionIntersections, {
      threshold: [0, 0.5, 1]
    });
  }

  syncTrackImpressionObserver() {
    if (!this.impressionTrackingEnabled()) {
      this.clearAllTrackImpressionTimers();
      if (this.trackImpressionObserver) {
        this.trackImpressionObserver.disconnect();
      }
      return;
    }

    this.ensureTrackImpressionObserver();
    if (!this.trackImpressionObserver) {
      return;
    }

    this.trackImpressionObserver.disconnect();
    this.getVisibleTracks(this.state.data).forEach(function(track) {
      let element = this.trackImpressionElements.get(track.id);
      if (element) {
        this.trackImpressionObserver.observe(element);
      }
    }.bind(this));
  }

  handleTrackImpressionIntersections(entries) {
    if (document.visibilityState === 'hidden') {
      this.clearAllTrackImpressionTimers();
      return;
    }

    entries.forEach(function(entry) {
      let element = entry.target;
      let trackId = parseInt(element.dataset.trackId, 10);
      if (!trackId) {
        return;
      }

      this.trackVisibilityRatios.set(trackId, entry.intersectionRatio);

      if (entry.intersectionRatio >= 0.5 && entry.isIntersecting && element.offsetParent !== null) {
        this.startTrackImpressionTimer(trackId, element);
      } else {
        this.clearTrackImpressionTimer(trackId);
      }
    }.bind(this));
  }

  startTrackImpressionTimer(trackId, element) {
    let impressionKey = this.buildTrackedImpressionKey(trackId);
    if (this.trackedImpressionKeys.has(impressionKey) || this.trackImpressionTimers.has(trackId)) {
      return;
    }

    let timeoutHandle = window.setTimeout(function() {
      this.trackImpressionTimers.delete(trackId);

      if (document.visibilityState === 'hidden') {
        return;
      }

      if ((this.trackVisibilityRatios.get(trackId) || 0) < 0.5) {
        return;
      }

      if (!element || element.offsetParent === null) {
        return;
      }

      this.queueTrackImpression(trackId, element);
    }.bind(this), 400);

    this.trackImpressionTimers.set(trackId, timeoutHandle);
  }

  clearTrackImpressionTimer(trackId) {
    let timeoutHandle = this.trackImpressionTimers.get(trackId);
    if (!timeoutHandle) {
      return;
    }

    window.clearTimeout(timeoutHandle);
    this.trackImpressionTimers.delete(trackId);
  }

  clearAllTrackImpressionTimers() {
    this.trackImpressionTimers.forEach(function(timeoutHandle) {
      window.clearTimeout(timeoutHandle);
    });
    this.trackImpressionTimers.clear();
  }

  buildTrackedImpressionKey(trackId) {
    let rankingContextKey = this.state.rankingContext && this.state.rankingContext.ranking_context_key;
    return [trackId, rankingContextKey].join(':');
  }

  queueTrackImpression(trackId, element) {
    let impressionKey = this.buildTrackedImpressionKey(trackId);
    if (this.trackedImpressionKeys.has(impressionKey)) {
      return;
    }

    this.trackedImpressionKeys.add(impressionKey);
    this.pendingImpressions.push({
      track_id: trackId,
      position: parseInt(element.dataset.rankingPosition, 10) || parseInt(element.dataset.rankingPagePosition, 10) || 0,
      is_exploration_lane: element.dataset.isExplorationLane === 'true',
      impressed_at: new Date().toISOString()
    });

    if (this.pendingImpressions.length >= 10) {
      this.flushPendingImpressions();
      return;
    }

    this.scheduleTrackImpressionFlush();
  }

  scheduleTrackImpressionFlush() {
    if (this.impressionFlushTimeout) {
      return;
    }

    this.impressionFlushTimeout = window.setTimeout(function() {
      this.impressionFlushTimeout = null;
      this.flushPendingImpressions();
    }.bind(this), 3000);
  }

  flushPendingImpressions(options = {}) {
    if (!this.pendingImpressions.length || !this.state.rankingContext) {
      return Promise.resolve(false);
    }

    if (this.impressionFlushTimeout) {
      window.clearTimeout(this.impressionFlushTimeout);
      this.impressionFlushTimeout = null;
    }

    let impressions = this.pendingImpressions.slice();
    this.pendingImpressions = [];

    return sendTrackImpressionBatch({
      event_name: 'track_impression_batch',
      ...currentMarketingTrackingPayload(),
      ranking_context_key: this.state.rankingContext.ranking_context_key,
      surface_type: this.state.rankingContext.surface_type,
      controller_name: this.state.rankingContext.controller_name,
      action_name: this.state.rankingContext.action_name,
      query: this.state.rankingContext.query,
      sort_by: this.state.rankingContext.sort_by,
      page: this.state.rankingContext.page,
      per_page: this.state.rankingContext.per_page,
      locale: this.state.rankingContext.locale,
      include_pro: this.state.rankingContext.include_pro,
      filters: this.state.rankingContext.filters,
      user_tracking_context: currentUserTrackingContext(),
      landing_key: this.state.rankingContext.landing_key,
      request_path: this.state.rankingContext.request_path,
      use_case_key: this.state.rankingContext.use_case_key,
      search_query_id: this.state.searchQueryId || this.state.rankingContext.search_query_id,
      page_instance_id: this.pageInstanceId,
      impressions: impressions
    }, options);
  }

  handlePageHide() {
    this.flushPendingImpressions({ useBeacon: true });
  }

  handleVisibilityChange() {
    if (document.visibilityState === 'hidden') {
      this.clearAllTrackImpressionTimers();
      this.flushPendingImpressions({ useBeacon: true });
    }
  }

  trackIsFavorited(trackId, favorites) {
      let i,
          favoritesLength = favorites && favorites.length ? favorites.length : 0;

      for (i = 0; i < favoritesLength; i += 1) {
          if (favorites[i].track_id === trackId) {
              return true;
          }
      }
      return false;
  }

  trackIsPurchased(trackId) {
    return !!this.props.purchasedTrackIds[trackId];
  }

  trackPurchaseCount(trackId) {
    if (this.trackIsPurchased(trackId)) {
      return this.props.purchasedTrackIds[trackId];
    } else {
      return 0;
    }
  }


  handleCartClick(trackId) {
      let stateObject = {},
          indexOfTrackId = this.state.showUsageLicenseSelectForTrackId.indexOf(trackId);

      if (indexOfTrackId === -1) {
          stateObject = {};
          stateObject['showUsageLicenseSelectForTrackId'] = [];
          stateObject['showUsageLicenseSelectForTrackId'].push(trackId);
      } else {
          legacyEventHub.trigger('closePopupMenus');
      }

      this.setState(stateObject);
  }

  handleUsageLicenseTypeSelectClose(trackId) {
      this.setState({
        showUsageLicenseSelectForTrackId: this.state.showUsageLicenseSelectForTrackId.filter(function(openTrackId) {
          return openTrackId !== trackId;
        })
      });
  }

  handleFreeDownloadClick(trackId) {
    let stateObject = {},
        indexOfTrackId = this.state.showFreeDownloadDialogForTrackId.indexOf(trackId);

    if (indexOfTrackId === -1) {
        stateObject = {};
        stateObject['showFreeDownloadDialogForTrackId'] = [];
        stateObject['showFreeDownloadDialogForTrackId'].push(trackId);
    } else {
        legacyEventHub.trigger('closePopupMenus');
    }

    this.setState(stateObject);
  }

  handlePaginationClick(page) {
    if (!this.props.useAjaxPagination) {
      return;
    }

    const requestedPage = Array.isArray(page) ? page[0] : page;

    if (!requestedPage || requestedPage === this.state.pagination.current_page) {
      return;
    }

    return this.sendAjaxPaginationQuery(requestedPage).catch(function(error) {
      this.pendingScrollTrigger = null;
      legacyEventHub.trigger('searchSuccess');
      console.warn('TrackListing pagination request failed', error);
      return null;
    }.bind(this));
  }

  handleEventHubPaginationClick(page) {
    this.pendingScrollTrigger = 'pagination';
    this.handlePaginationClick(page);
  }

  sendAjaxPaginationQuery(page, options = {}) {
    const initialLoad = options.initialLoad === true;
    const baseQueryString = (this.state.pagination && this.state.pagination.current_query) || (window.location.search || '');
    const params = new URLSearchParams(baseQueryString);
    const listingPath = (this.state.pagination && this.state.pagination.path) || (window.location ? window.location.pathname : '/');

    if (page > 1) {
      params.set('page', page);
    } else {
      params.delete('page');
    }

    const queryString = params.toString();
    const htmlPath = `${listingPath}${queryString ? '?' + queryString : ''}`;
    const jsonPath = `${listingPath}.json${queryString ? '?' + queryString : ''}`;

    legacyEventHub.trigger(initialLoad ? 'fireSearchWithoutAnimation' : 'fireSearch');

    return requestJson(jsonPath).then(function(data) {
        legacyEventHub.trigger(initialLoad ? 'initialUpdateTrackListing' : 'updateTrackListing', data);
        legacyEventHub.trigger('searchSuccess', data);

        if (history.pushState) {
          const newUrl = `${window.location.protocol}//${window.location.host}${htmlPath}`.replace(/\?page=1$/, '');
          window.history.pushState({ path: newUrl }, '', newUrl);
        }
      }.bind(this)).catch(function(error) {
        if (initialLoad) {
          this.setState({ initialLoadPending: false });
        }

        throw error;
      }.bind(this));
  }

  scrollToListStart(triggerType = null) {
      const trackListingNode = this.getScrollAnchorNode();
      if (!trackListingNode || typeof trackListingNode.getBoundingClientRect !== 'function') {
        return;
      }

      const stickyOverlapHeight = this.getStickyOverlapHeight();
      const anchorRect = trackListingNode.getBoundingClientRect();
      const visibleOffset = anchorRect.top - stickyOverlapHeight;
      const isSearchTrigger = triggerType === 'search';

      if (!isSearchTrigger && visibleOffset >= -32 && visibleOffset <= 96) {
        return;
      }

      const currentScrollTop = window.pageYOffset || window.scrollY || 0;
      const listTop = anchorRect.top + currentScrollTop;
      const scrollTarget = Math.max(listTop - stickyOverlapHeight - 16, 0);
      const scrollDelta = Math.abs(currentScrollTop - scrollTarget);

      if ((isSearchTrigger && scrollDelta < 4) || (!isSearchTrigger && scrollDelta < 48)) {
        return;
      }

      if (typeof window.scrollTo === 'function') {
        window.scrollTo({ top: scrollTarget, behavior: 'smooth' });
        return;
      }

      window.scrollTo(0, scrollTarget);
  }

  scheduleScrollToListStart(triggerType = null) {
      const requestFrame = window.requestAnimationFrame || function(callback) {
        return window.setTimeout(callback, 0);
      };
      const cancelFrame = window.cancelAnimationFrame || window.clearTimeout;

      if (this.scrollFrameHandle !== null) {
        cancelFrame(this.scrollFrameHandle);
      }

      if (this.scrollRetryHandle !== null) {
        window.clearTimeout(this.scrollRetryHandle);
        this.scrollRetryHandle = null;
      }

      this.scrollFrameHandle = requestFrame(function() {
        this.scrollFrameHandle = requestFrame(function() {
          this.scrollFrameHandle = null;
          this.scrollToListStart(triggerType);

          if (triggerType === 'search') {
            this.scrollRetryHandle = window.setTimeout(function() {
              this.scrollRetryHandle = null;
              this.scrollToListStart(triggerType);
            }.bind(this), 160);
          }
        }.bind(this));
      }.bind(this));
  }

  getScrollAnchorNode() {
      const trackListingNode = this.trackListing || document.querySelector('.track-listing');
      if (!trackListingNode) {
        return null;
      }

      const headingNode = typeof trackListingNode.querySelector === 'function' ? trackListingNode.querySelector('.track-listing__count') : null;
      if (headingNode) {
        return headingNode;
      }

      const closestTrackListing = typeof trackListingNode.closest === 'function' ? trackListingNode.closest('#track-listing') : null;
      return closestTrackListing || trackListingNode.parentElement || trackListingNode;
  }

  getStickyOverlapHeight() {
      const stickyNodes = Array.from(document.querySelectorAll('.nav, .minimal-header, .search__sticky-layer, .search__sticky-layer .search__inputs'));
      const stickyRects = stickyNodes
        .filter(function(node) {
          return node && typeof node.getBoundingClientRect === 'function';
        })
        .map(function(node) {
          const rect = node.getBoundingClientRect();
          const computedStyle = window.getComputedStyle ? window.getComputedStyle(node) : null;
          const isStickyPosition = computedStyle && (computedStyle.position === 'sticky' || computedStyle.position === 'fixed');
          const configuredTop = computedStyle && computedStyle.top && computedStyle.top !== 'auto' ? parseFloat(computedStyle.top) : rect.top;

          return {
            top: Number.isFinite(configuredTop) ? configuredTop : rect.top,
            bottom: (Number.isFinite(configuredTop) ? configuredTop : rect.top) + rect.height,
            height: rect.height,
            isStickyPosition: isStickyPosition
          };
        })
        .filter(function(rect) {
          return rect.height > 0 && rect.isStickyPosition;
        })
        .sort(function(left, right) {
          return left.top - right.top;
        });

      let overlapBottom = 0;

      stickyRects.forEach(function(rect) {
        const top = Math.max(rect.top, 0);
        const bottom = Math.max(rect.bottom, 0);

        if (top <= overlapBottom + 1) {
          overlapBottom = Math.max(overlapBottom, bottom);
        }
      });

      return overlapBottom;
  }

  trackIsInCart(trackId, cartItems) {
      let i,
          cartItemsLength = cartItems && cartItems.length ? cartItems.length : 0;

      for (i = 0; i < cartItemsLength; i += 1) {
          if (cartItems[i].track_id === trackId) {
              return true;
          }
      }
      return false;
  }

  isUsageLicenseSelectVisible(trackId) {
      if (this.state.showUsageLicenseSelectForTrackId.indexOf(trackId) > -1) {
          return true;
      }

      return false;
  }

  isFreeDownloadDialogVisible(trackId) {
    if (this.state.showFreeDownloadDialogForTrackId.indexOf(trackId) > -1) {
      return true;
    }

    return false;
  }

  shouldRenderUsageLicenseTypeSelect(trackId) {
      let shouldRender = false;

      for (let i = 0; i < this.state.showUsageLicenseSelectForTrackId.length; i += 1) {
          if (this.state.showUsageLicenseSelectForTrackId[i] === trackId && typeof this.props.exposure_pack.id === 'undefined') {
             shouldRender = true;
          }
      }

      return shouldRender;
  }

  getContent() {
      return this.props.content.map(function(content, index) {
        return (
          <div className={this.props.content.length > 4 ? 'track-listing__content track-listing__content--long' : 'track-listing__content'} key={'track_listing_content_' + index}>
            <details className='track-listing__content-details' itemProp="mainEntity" itemScope itemType="https://schema.org/Question" open={content.open ? true : false}>
              <summary className='track-listing__content-title-wrapper' itemProp="name">{content.title}</summary>
              <div className='track-listing__content-description' itemProp="acceptedAnswer" itemScope itemType="https://schema.org/Answer"><div itemProp="text" dangerouslySetInnerHTML={{__html: content.description}}></div></div>
            </details>
          </div>
        )
      }.bind(this))
  }

  getNameFor(itemName, id) {
    return this.props.itemNames[itemName][id];
  }

  noSongsAvailableText() {
    return translateLegacyText('no_songs_available', {
      i18n: this.props.i18n,
      locale: this.props.locale
    });
  }

  isActiveItem(itemName, id) {
    const activeItems = this.state && this.state.currentQuery ? this.state.currentQuery[itemName] : null;
    return Array.isArray(activeItems) ? activeItems.indexOf(id) > -1 : false;
  }

  tagMetadataById() {
    if (this._tagMetadataById) {
      return this._tagMetadataById;
    }

    this._tagMetadataById = (Array.isArray(this.props.tags) ? this.props.tags : []).reduce((memo, tag) => {
      if (tag && typeof tag.id !== 'undefined') {
        memo[String(tag.id)] = tag;
      }

      return memo;
    }, {});

    return this._tagMetadataById;
  }

  getSuggestedTopicTags(tagIds, trackId) {
    if (!Array.isArray(tagIds) || tagIds.length === 0) {
      return [];
    }

    let tagLookup = this.tagMetadataById();
    let prioTags = tagIds
      .map((tagId) => tagLookup[String(tagId)])
      .filter((tag, index, tags) => tag && tag.prio && tags.findIndex((candidate) => candidate && candidate.id === tag.id) === index);

    if (prioTags.length === 0) {
      return [];
    }

    let activeTagIds = Array.isArray(this.state.currentQuery.tags) ? this.state.currentQuery.tags.map(String) : [];
    let activePrioTags = prioTags.filter((tag) => activeTagIds.indexOf(String(tag.id)) > -1);
    let inactivePrioTags = prioTags.filter((tag) => activeTagIds.indexOf(String(tag.id)) === -1);
    let prioritizedTags = this.sortSuggestedTopicTags(inactivePrioTags, trackId);

    if (prioritizedTags.length <= 3) {
      return activePrioTags.concat(prioritizedTags).slice(0, 3);
    }

    return activePrioTags.concat(prioritizedTags).slice(0, 3);
  }

  suggestedTopicPriorityScore(tag) {
    let label = String(tag?.name || '').toLowerCase();

    if (label.indexOf('podcast') > -1) {
      return 200;
    }

    if (label.indexOf('opener') > -1) {
      return 180;
    }

    if (label.indexOf('intro') > -1 || label.indexOf('einleitung') > -1) {
      return 170;
    }

    return 0;
  }

  sortSuggestedTopicTags(tags, trackId) {
    if (!Array.isArray(tags) || tags.length === 0) {
      return [];
    }

    let rotation = Number.isInteger(trackId) ? Math.abs(trackId) % tags.length : 0;

    return tags
      .map(function(tag, index) {
        let rotatedIndex = (index - rotation + tags.length) % tags.length;

        return {
          tag: tag,
          priority: this.suggestedTopicPriorityScore(tag),
          rotatedIndex: rotatedIndex
        };
      }.bind(this))
      .sort(function(a, b) {
        if (a.priority !== b.priority) {
          return b.priority - a.priority;
        }

        return a.rotatedIndex - b.rotatedIndex;
      })
      .map(function(entry) {
        return entry.tag;
      });
  }

  getSelectedUsageLicenseTypeIdsForExposurePack() {
    let ids = [],
        that = this,
        exposurePackId = this.props.exposure_pack.id || that.state.data.exposure_pack.id,
        cart_items = this.state.cart_items || this.props.cart_items;

    cart_items.forEach(function(element) {
        if (element.exposure_pack_id === exposurePackId) {
            ids.push(element.usage_license_type_id);
        }
    });

    return ids;
  }

  getPanelValue(panel, key) {
    if (!panel) return '';
    if (typeof panel[key] !== 'undefined') return panel[key];

    let snakeCaseKey = key.replace(/[A-Z]/g, function(char) {
      return '_' + char.toLowerCase();
    });

    if (typeof panel[snakeCaseKey] !== 'undefined') return panel[snakeCaseKey];
    return '';
  }

  getIncludeProScopeValue() {
    let includeProValue = this.state.currentQuery && this.state.currentQuery.includePro;

    if (includeProValue === true || includeProValue === 'true') {
      return 0;
    }

    if (includeProValue === false || includeProValue === 'false') {
      return 2;
    }

    let parsedStateValue = parseInt(includeProValue, 10);

    if (!isNaN(parsedStateValue)) {
      return parsedStateValue;
    }

    return 2;
  }

  getNavigatorPanelsNode() {
    let hasInsert = this.props.listingInsert || (Array.isArray(this.props.navigatorPanels) && this.props.navigatorPanels.length > 0);
    if (!hasInsert) {
      return null;
    }
    let infoText = this.props.locale === 'de'
      ? 'Unsicher bei der Lizenzwahl?'
      : 'Unsure which license is right?';
    let linkLabel = this.props.locale === 'de' ? 'Lizenz-Navigator starten' : 'Start license navigator';
    let linkHref = this.props.licenseNavigatorPath || '/lizenz-navigator';

    return (
      <div key='track_listing_insert' className='track-listing__insert'>
        {infoText} <a href={linkHref}>{linkLabel}</a>
      </div>
    );
  }

  render() {
      let activeTrackId = this.state.active_track_id;
      let activeTrackVariantId = this.state.activeTrackVariantId;
      let content = [];
      let clientListing = [];
      let visibleTracks = this.getVisibleTracks();

      let tracks = visibleTracks.map(function (track, index) {
              let prevProps = null;
              let nextProps = null;
              let currentProps = {
                  id : track.id,
                  composerName: track.composer_name,
                  composerUrl: track.composer_url,
                  showcaseUrl: track.showcase_url,
                  i18n : this.props.i18n,
                  title : track.title,
                  display_title : this.props.exposurePackMode ? (track.public_performance_title || track.display_title) : track.display_title,
                  publicPerformanceTitle : track.public_performance_title,
                  active : track.id === activeTrackId,
                  activeTrackVariantId : activeTrackVariantId,
                  key : "track-" + track.id,
                  length : track.length,
                  short_description : track.short_description,
                  inCart : this.trackIsInCart(track.id, this.state.cart_items),
                  free : track.free,
                  hideItemIdList: this.props.hideItemIdList,
                  hideTagLinks: this.props.hideTagLinks,
                  hideAddToCart: this.props.hideAddToCart,
                  genre_id_list : track.genre_id_list,
                  tag_id_list : track.tag_id_list,
                  mood_id_list : track.mood_id_list,
                  suggestedTopicTags: this.getSuggestedTopicTags(track.tag_id_list, track.id),
                  isActiveItem : this.isActiveItem,
                  discount : track.discount,
                  copyrightYear : track.copyright_year,
                  recently_activated : track.recently_activated,
                  usageLicenseTypes : this.props.usageLicenseTypes.filter(function(usageLicenseType) { return usageLicenseType.for_fx === false }),
                  subscribedUsageLicenseTypes: this.props.subscribedUsageLicenseTypes,
                  pricing_path : this.props.pricing_path,
                  licenseNavigatorPath: this.props.licenseNavigatorPath,
                  gemaNavigatorPath: this.props.gemaNavigatorPath,
                  gemaNavigatorTooltip: this.props.gemaNavigatorTooltip,
                  allowedProjectLicenseFamilyKeys: this.props.allowedProjectLicenseFamilyKeys,
                  cart_items : this.state.cart_items,
                  trackFavorites : this.state.trackFavorites,
                  favorited : this.trackIsFavorited(track.id, this.state.trackFavorites),
                  purchased : this.trackIsPurchased(track.id),
                  purchaseCount : this.trackPurchaseCount(track.id),
                  handleFavoriteClick : this.handleFavoriteClick,
                  showUsageLicenseSelect : this.isUsageLicenseSelectVisible(track.id),
                  showFreeDownloadDialog : this.isFreeDownloadDialogVisible(track.id),
                  handleCartClick : this.handleCartClick,
                  handleUsageLicenseTypeSelectClose : this.handleUsageLicenseTypeSelectClose,
                  handleFreeDownloadClick: this.handleFreeDownloadClick,
                  show_download_button : this.props.show_download_button,
                  search_in_progress: this.state.searchInProgress,
                  exposure_pack: this.props.exposure_pack,
                  exposurePackMode: this.props.exposurePackMode,
                  score: track.score,
                  getNameFor: this.getNameFor,
                  freeMode: this.props.freeMode,
                  track_variants: track.track_variants,
                  waveform_inactive: track.waveform_inactive,
                  waveform_loaded: track.waveform_loaded,
                  waveform_played: track.waveform_played,
                  energy_level: track.energy_level,
                  energy_score: track.energy_score,
                  track_image_markup: track.track_image,
                  youtube_content_id_enabled: track.youtube_content_id_enabled,
                  royaltyFree : track.royalty_free,
                  pro_short_name : track.pro_short_name,
                  included_media_bundles : track.included_media_bundles,
                  minLengthFilter: this.state.currentQuery.minLength,
                  maxLengthFilter: this.state.currentQuery.maxLength,
                  loopFilter: this.state.currentQuery.loop,
                  locale: this.props.locale,
                  showProTrackBadge: this.props.showProTrackBadge,
                  licenseActionLabel: this.props.licenseActionLabel,
                  projectActionEnabled: true
              }

              if (typeof visibleTracks[index+1] !== 'undefined') {
                  let nextTrack = visibleTracks[index+1];
                  nextProps = {
                      id : nextTrack.id,
                      composerName: nextTrack.composer_name,
                      composerUrl: nextTrack.composer_url,
                      showcaseUrl: nextTrack.showcase_url,
                      i18n : this.props.i18n,
                      title : nextTrack.title,
                      display_title : this.props.exposurePackMode ? (nextTrack.public_performance_title || nextTrack.display_title) : nextTrack.display_title,
                      publicPerformanceTitle : nextTrack.public_performance_title,
                      active : nextTrack.id === activeTrackId,
                      activeTrackVariantId : activeTrackVariantId,
                      key : "track-" + nextTrack.id,
                      length : nextTrack.length,
                      short_description : nextTrack.short_description,
                      inCart : this.trackIsInCart(nextTrack.id, this.state.cart_items),
                      free : nextTrack.free,
                      hideItemIdList: this.props.hideItemIdList,
                      hideTagLinks: this.props.hideTagLinks,
                      hideAddToCart: this.props.hideAddToCart,
                      genre_id_list : nextTrack.genre_id_list,
                      tag_id_list : nextTrack.tag_id_list,
                      mood_id_list : nextTrack.mood_id_list,
                      suggestedTopicTags: this.getSuggestedTopicTags(nextTrack.tag_id_list, nextTrack.id),
                      isActiveItem : this.isActiveItem,
                      discount : nextTrack.discount,
                      copyrightYear : nextTrack.copyright_year,
                      recently_activated : nextTrack.recently_activated,
                      usageLicenseTypes : this.props.usageLicenseTypes.filter(function(usageLicenseType) { return usageLicenseType.for_fx === false }),
                      subscribedUsageLicenseTypes: this.props.subscribedUsageLicenseTypes,
                      pricing_path : this.props.pricing_path,
                      licenseNavigatorPath: this.props.licenseNavigatorPath,
                      gemaNavigatorPath: this.props.gemaNavigatorPath,
                      gemaNavigatorTooltip: this.props.gemaNavigatorTooltip,
                      allowedProjectLicenseFamilyKeys: this.props.allowedProjectLicenseFamilyKeys,
                      cart_items : this.state.cart_items,
                      trackFavorites : this.state.trackFavorites,
                      favorited : this.trackIsFavorited(nextTrack.id, this.state.trackFavorites),
                      purchased : this.trackIsPurchased(nextTrack.id),
                      purchaseCount : this.trackPurchaseCount(nextTrack.id),
                      handleFavoriteClick : this.handleFavoriteClick,
                      showUsageLicenseSelect : this.isUsageLicenseSelectVisible(nextTrack.id),
                      showFreeDownloadDialog : this.isFreeDownloadDialogVisible(nextTrack.id),
                      handleCartClick : this.handleCartClick,
                      handleFreeDownloadClick: this.handleFreeDownloadClick,
                      show_download_button : this.props.show_download_button,
                      exposure_pack: this.props.exposure_pack,
                      exposurePackMode: this.props.exposurePackMode,
                      score: nextTrack.score,
                      getNameFor: this.getNameFor,
                      freeMode: this.props.freeMode,
                      track_variants: nextTrack.track_variants,
                      waveform_inactive: nextTrack.waveform_inactive,
                      waveform_loaded: nextTrack.waveform_loaded,
                      waveform_played: nextTrack.waveform_played,
                      energy_level: nextTrack.energy_level,
                      energy_score: nextTrack.energy_score,
                      handleVariantClick: this.handleVariantClick,
                      track_image_markup: nextTrack.track_image,
                      youtube_content_id_enabled: nextTrack.youtube_content_id_enabled,
                      royaltyFree : nextTrack.royalty_free,
                      pro_short_name : nextTrack.pro_short_name,
                      included_media_bundles : nextTrack.included_media_bundles,
                      locale: this.props.locale,
                      showProTrackBadge: this.props.showProTrackBadge,
                      licenseActionLabel: this.props.licenseActionLabel,
                      projectActionEnabled: true
                  };
              }

              if (typeof visibleTracks[index-1] !== 'undefined') {
                  let prevTrack = visibleTracks[index-1];
                  prevProps = {
                      id : prevTrack.id,
                      composerName: prevTrack.composer_name,
                      composerUrl: prevTrack.composer_url,
                      showcaseUrl: prevTrack.showcase_url,
                      i18n : this.props.i18n,
                      title : prevTrack.title,
                      display_title : this.props.exposurePackMode ? (prevTrack.public_performance_title || prevTrack.display_title) : prevTrack.display_title,
                      publicPerformanceTitle : prevTrack.public_performance_title,
                      active : prevTrack.id === activeTrackId,
                      activeTrackVariantId : activeTrackVariantId,
                      key : "track-" + prevTrack.id,
                      length : prevTrack.length,
                      short_description : prevTrack.short_description,
                      inCart : this.trackIsInCart(prevTrack.id, this.state.cart_items),
                      free : prevTrack.free,
                      hideItemIdList: this.props.hideItemIdList,
                      hideTagLinks: this.props.hideTagLinks,
                      hideAddToCart: this.props.hideAddToCart,
                      genre_id_list : prevTrack.genre_id_list,
                      tag_id_list : prevTrack.tag_id_list,
                      mood_id_list : prevTrack.mood_id_list,
                      suggestedTopicTags: this.getSuggestedTopicTags(prevTrack.tag_id_list, prevTrack.id),
                      isActiveItem : this.isActiveItem,
                      discount : prevTrack.discount,
                      copyrightYear : prevTrack.copyright_year,
                      recently_activated : prevTrack.recently_activated,
                      usageLicenseTypes : this.props.usageLicenseTypes.filter(function(usageLicenseType) { return usageLicenseType.for_fx === false }),
                      subscribedUsageLicenseTypes: this.props.subscribedUsageLicenseTypes,
                      pricing_path : this.props.pricing_path,
                      licenseNavigatorPath: this.props.licenseNavigatorPath,
                      gemaNavigatorPath: this.props.gemaNavigatorPath,
                      gemaNavigatorTooltip: this.props.gemaNavigatorTooltip,
                      allowedProjectLicenseFamilyKeys: this.props.allowedProjectLicenseFamilyKeys,
                      cart_items : this.state.cart_items,
                      trackFavorites : this.state.trackFavorites,
                      favorited : this.trackIsFavorited(prevTrack.id, this.state.trackFavorites),
                      purchased : this.trackIsPurchased(prevTrack.id),
                      purchaseCount : this.trackPurchaseCount(prevTrack.id),
                      handleFavoriteClick : this.handleFavoriteClick,
                      showUsageLicenseSelect : this.isUsageLicenseSelectVisible(prevTrack.id),
                      showFreeDownloadDialog : this.isFreeDownloadDialogVisible(prevTrack.id),
                      handleCartClick : this.handleCartClick,
                      handleFreeDownloadClick: this.handleFreeDownloadClick,
                      show_download_button : this.props.show_download_button,
                      exposure_pack: this.props.exposure_pack,
                      exposurePackMode: this.props.exposurePackMode,
                      score: prevTrack.score,
                      getNameFor: this.getNameFor,
                      freeMode: this.props.freeMode,
                      track_variants: prevTrack.track_variants,
                      waveform_inactive: prevTrack.waveform_inactive,
                      waveform_loaded: prevTrack.waveform_loaded,
                      waveform_played: prevTrack.waveform_played,
                      energy_level: prevTrack.energy_level,
                      energy_score: prevTrack.energy_score,
                      handleVariantClick: this.handleVariantClick,
                      track_image_markup: prevTrack.track_image,
                      youtube_content_id_enabled: prevTrack.youtube_content_id_enabled,
                      royaltyFree : prevTrack.royalty_free,
                      pro_short_name : prevTrack.pro_short_name,
                      included_media_bundles : prevTrack.included_media_bundles,
                      locale: this.props.locale,
                      showProTrackBadge: this.props.showProTrackBadge,
                      licenseActionLabel: this.props.licenseActionLabel,
                      projectActionEnabled: true
                  };
              }

              Object.assign(currentProps, this.rankingTrackingPropsForTrack(track), {
                impressionRef: this.impressionRefForTrack(track.id)
              });

              if (nextProps) {
                Object.assign(nextProps, this.rankingTrackingPropsForTrack(visibleTracks[index+1]));
              }

              if (prevProps) {
                Object.assign(prevProps, this.rankingTrackingPropsForTrack(visibleTracks[index-1]));
              }

              if (index === 2 && this.props.content && this.props.content.length > 0 && this.state.pagination.current_page === 1) {
                content = this.getContent();
              } else {
                content = [];
              }

              // if (index === 10 && this.props.clientListing && this.props.clientListing.length > 0 && this.state.pagination.current_page === 1) {
              //   clientListing = this.props.clientListing.map(function(client, index) {
              //     return (
              //       <div className='track-listing__client' key={'track_listing_client_' + index}>
              //         {client}
              //       </div>
              //     )
              //   }.bind(this));
              // } else {
              //   clientListing = [];
              // }

              return (
                <div key={'track_wrapper_' + track.id}>
                  <Track {...currentProps} next_track={nextProps} prev_track={prevProps} key={'track_' + track.id}/>
                  {content.length === 0 ? '' : (<div className='track-listing__content-wrapper' itemScope itemType="https://schema.org/FAQPage"><h2 className='text-like-h4'>{this.props.locale === 'de' ? 'Oft gestellte Fragen' : 'FAQ'}</h2><div className='track-listing__content-symbol'><i className='fa fa-info'></i></div><div className='track-listing__contents'>{content}</div></div>)}
                  {clientListing.length === 0 ? '' : (<div className='track-listing__client-wrapper'><h2 className='text-like-h4'>{this.props.locale === 'de' ? 'Diese Marken vertrauen auf unsere Komponisten' : 'These brands rely on our composers'}</h2><div className='track-listing__clients'>{clientListing}</div></div>)}
                </div>
              );

          }.bind(this));

      let navigatorPanelsNode = this.getNavigatorPanelsNode();
      let trackAndPanelNodes = tracks.slice();

      if (trackAndPanelNodes.length > 0 && navigatorPanelsNode) {
        let insertIndex = typeof this.props.listingInsertIndex === 'number' ? this.props.listingInsertIndex : this.props.navigatorPanelInsertIndex;
        let insertAt = Math.min(insertIndex, trackAndPanelNodes.length);
        trackAndPanelNodes.splice(insertAt, 0, navigatorPanelsNode);
      }

      let pagination = function() {
        if (this.props.show_pagination && this.state.pagination.total_count > 10) {
            return (
              <Pagination data={this.state.pagination} i18n={this.props.i18n} genre_id={this.props.genre_id} composer_page_permalink={this.props.composer_page_permalink}/>
            )
        }
      }.bind(this);

      let spinner = function() {
        if (this.state.searchInProgress) {
          return (
            <div className='loading-bars'>
              <span className='loading-bars__element'></span>
              <span className='loading-bars__element'></span>
              <span className='loading-bars__element'></span>
              <span className='loading-bars__element'></span>
              <span className='loading-bars__element'></span>
              <span className='loading-bars__element'></span>
              <span className='loading-bars__element'></span>
              <span className='loading-bars__element'></span>
              <span className='loading-bars__element'></span>
              <span className='loading-bars__element'></span>
              <span className='loading-bars__element'></span>
              <span className='loading-bars__element'></span>
              <span className='loading-bars__element'></span>
              <span className='loading-bars__element'></span>
              <span className='loading-bars__element'></span>
            </div>
          )
        }
      }.bind(this);

      let smiley = function() {
        return (
          <div className='track-listing-smiley'>
            <div className='track-listing-smiley-icon'>
              <i className='fa fa-frown-o' />
            </div>
          </div>
        )
      }.bind(this);

      let includeProScopeValue = this.getIncludeProScopeValue();
      let proStateHint = (<span className="track-listing__pro-state"></span>);
      let proScopeInsertNode = null;

      if (this.props.showProScopeHint && includeProScopeValue === 0) {
        proStateHint = (<span className="track-listing__pro-state">{this.props.locale === 'de' ? 'GEMA-frei und P.R.O.' : 'P.R.O. and royalty free'}</span>);
        proScopeInsertNode = (
          <div className='track-listing__insert' key='track_listing_pro_scope_hint'>
            {this.props.proScopeHintText ? (
              this.props.proScopeHintText
            ) : this.props.locale === 'de' ? (
              <span>
                Hinweis: PRO-Musik kann bei TV/Broadcast oder öffentlicher Nutzung zusätzliche Gebühren bei Verwertungsgesellschaften verursachen.
                {' '}
                Nicht sicher, ob GEMAfreie Musik oder PRO Musik passt?
                {' '}
                <a href={this.props.gemaNavigatorPath || '/service/gema-navigator'}>GEMA-Navigator starten</a>
              </span>
            ) : (
              'Note: PRO tracks can trigger additional collecting-society royalties for TV, broadcast, or public performance.'
            )}
          </div>
        );
      }

      if (this.props.showProScopeHint && includeProScopeValue === 1) {
        proStateHint = (<span className="track-listing__pro-state">{this.props.locale === 'de' ? 'P.R.O. (GEMA-pflichtig)' : 'P.R.O.'}</span>);
      }

      if (this.props.showProScopeHint && includeProScopeValue === 2) {
        proStateHint = (<span className="track-listing__pro-state">{this.props.locale === 'de' ? 'GEMA-frei' : 'Royalty free'}</span>);
      }

      const shouldRenderInitialPlaceholder = this.state.initialLoadPending && tracks.length === 0 && visibleTracks.length === 0;

      let classes = classNames({
            'track-listing': true,
            'track-listing-with-pagination': this.props.show_pagination,
            'is-spinning': this.state.searchInProgress,
            'is-empty': this.state.data.length === 0,
            'track-listing-animation-finished': this.state.animationFinished,
            'track-listing--track-show': this.props.trackShow,
            [this.props.className]: !!this.props.className
          });

      let tracksDuration = 0;

      for (let i = 0; i < visibleTracks.length; i+=1) {
          tracksDuration += visibleTracks[i].length;
      }

    if (typeof this.props.exposure_pack !== 'undefined' && this.props.exposure_pack.id && !this.props.exposurePackPreviewMode) {
        return (
          <div className='row'>
            <div className='show-md-down col3 col6-md offset3-md col12-sm search-tabs-wrapper'>
              <UsageLicenseTypeSelectSidebar
                  addToCart={this.props.i18n.add_to_cart}
                  free={this.props.free}
                  discount={this.props.discount}
                  exposure_pack={this.props.exposure_pack}
                  usageLicenseTypes={this.props.usageLicenseTypes.filter(function(usageLicenseType) { return usageLicenseType.for_fx === false })}
                  updateCart={this.updateCart}
                  pricing_path={this.props.pricing_path}
                  selectedUsageLicenseTypeIds={this.getSelectedUsageLicenseTypeIdsForExposurePack()}
                  i18n={this.props.i18n}
                  visible={this.props.showUsageLicenseSelect}
                  position='bottom'
                  show_download_button={this.props.show_download_button}
                  title={this.props.exposure_pack.title}
                  trackCount={trackAndPanelNodes.length}
                  totalDuration={this.props.exposure_pack.duration} />
            </div>
            <div className='col9 col12-md-down'>
              <div className={classes} ref={this.setTrackListing}>
                {(this.state.data.length === 0 && (typeof this.state.pagination.current_page === 'undefined')) ? this.getContent() : ''}
                {(tracks.length === 0 && visibleTracks.length === 0 && (typeof this.state.pagination.current_page === 'undefined')) ? this.getContent() : ''}
                {trackAndPanelNodes.length > 0 ? trackAndPanelNodes : (visibleTracks.length == 0 ? '' : this.noSongsAvailableText())}
                {pagination()}
                {spinner()}
                {smiley()}
              </div>
            </div>
            <div className='col3 col6-md offset3-md col12-sm search-tabs-wrapper'>
              <UsageLicenseTypeSelectSidebar
                  addToCart={this.props.i18n.add_to_cart}
                  free={this.props.free}
                  discount={this.props.discount}
                  exposure_pack={this.props.exposure_pack}
                  usageLicenseTypes={this.props.usageLicenseTypes.filter(function(usageLicenseType) { return usageLicenseType.for_fx === false })}
                  updateCart={this.updateCart}
                  pricing_path={this.props.pricing_path}
                  selectedUsageLicenseTypeIds={this.getSelectedUsageLicenseTypeIdsForExposurePack()}
                  i18n={this.props.i18n}
                  visible={this.props.showUsageLicenseSelect}
                  position='bottom'
                  show_download_button={this.props.show_download_button}
                  title={this.props.exposure_pack.title}
                  trackCount={visibleTracks.length}
                  totalDuration={this.props.exposure_pack.duration} />
            </div>
          </div>
        )
    } else {
      let countValue = this.state.pagination.total_count;
      let countLabel = this.state.pagination.total_count === 1 ? 'Track' : 'Tracks';
      let shouldUseMarketingCount = this.props.marketingCountLabel && this.state.currentQuery && this.state.currentQuery.noFiltersActive;

      if (shouldUseMarketingCount) {
        countValue = this.props.marketingCountLabel;
        countLabel = '';
      }

      if (this.props.showHeading) {
        return (
          <div className={classes} ref={this.setTrackListing}>
            <div className="track-listing__count"><span className='track-listing__count-value'>{countValue}</span>{countLabel ? ` ${countLabel}` : ''}{proStateHint}</div>
            {proScopeInsertNode}
            {(tracks.length === 0 && visibleTracks.length === 0 && ((typeof this.state.pagination.current_page === 'undefined') || shouldRenderInitialPlaceholder)) ? <TrackBarebone locale={this.props.locale}/> : ''}
            {(tracks.length === 0 && visibleTracks.length === 0 && ((typeof this.state.pagination.current_page === 'undefined') || shouldRenderInitialPlaceholder)) ? <TrackBarebone locale={this.props.locale}/> : ''}
            {(tracks.length === 0 && visibleTracks.length === 0 && ((typeof this.state.pagination.current_page === 'undefined') || shouldRenderInitialPlaceholder)) ? <TrackBarebone locale={this.props.locale}/> : ''}
            {(tracks.length === 0 && visibleTracks.length === 0 && (typeof this.state.pagination.current_page === 'undefined')) ? (<div className='track-listing__content-wrapper' itemScope itemType="https://schema.org/FAQPage"><h2 className='text-like-h4'>{this.props.locale === 'de' ? 'Oft gestellte Fragen' : 'FAQ'}</h2><div className='track-listing__content-symbol'><i className='fa fa-info'></i></div><div className='track-listing__contents'>{this.getContent()}</div></div>) : ''}
            {(tracks.length === 0 && visibleTracks.length === 0 && ((typeof this.state.pagination.current_page === 'undefined') || shouldRenderInitialPlaceholder)) ? <TrackBarebone locale={this.props.locale}/> : ''}
            {(tracks.length === 0 && visibleTracks.length === 0 && ((typeof this.state.pagination.current_page === 'undefined') || shouldRenderInitialPlaceholder)) ? <TrackBarebone locale={this.props.locale}/> : ''}
            {(tracks.length === 0 && visibleTracks.length === 0 && ((typeof this.state.pagination.current_page === 'undefined') || shouldRenderInitialPlaceholder)) ? <TrackBarebone locale={this.props.locale}/> : ''}
            {(tracks.length === 0 && visibleTracks.length === 0 && ((typeof this.state.pagination.current_page === 'undefined') || shouldRenderInitialPlaceholder)) ? <TrackBarebone locale={this.props.locale}/> : ''}
            {(tracks.length === 0 && visibleTracks.length === 0 && ((typeof this.state.pagination.current_page === 'undefined') || shouldRenderInitialPlaceholder)) ? <TrackBarebone locale={this.props.locale}/> : ''}
            {(tracks.length === 0 && visibleTracks.length === 0 && ((typeof this.state.pagination.current_page === 'undefined') || shouldRenderInitialPlaceholder)) ? <TrackBarebone locale={this.props.locale}/> : ''}
            {trackAndPanelNodes.length > 0 ? trackAndPanelNodes : (visibleTracks.length == 0 ? '' : this.noSongsAvailableText())}
            {pagination()}
            {spinner()}
            {smiley()}
          </div>
        )
      } else {
        return (
          <div className={classes} ref={this.setTrackListing}>
            {(tracks.length === 0 && visibleTracks.length === 0 && ((typeof this.state.pagination.current_page === 'undefined') || shouldRenderInitialPlaceholder)) ? <TrackBarebone locale={this.props.locale}/> : ''}
            {(tracks.length === 0 && visibleTracks.length === 0 && ((typeof this.state.pagination.current_page === 'undefined') || shouldRenderInitialPlaceholder)) ? <TrackBarebone locale={this.props.locale}/> : ''}
            {(tracks.length === 0 && visibleTracks.length === 0 && ((typeof this.state.pagination.current_page === 'undefined') || shouldRenderInitialPlaceholder)) ? <TrackBarebone locale={this.props.locale}/> : ''}
            {(tracks.length === 0 && visibleTracks.length === 0 && (typeof this.state.pagination.current_page === 'undefined')) ? (<div className='track-listing__content-wrapper' itemScope itemType="https://schema.org/FAQPage"><h2 className='text-like-h4'>{this.props.locale === 'de' ? 'Oft gestellte Fragen' : 'FAQ'}</h2><div className='track-listing__content-symbol'><i className='fa fa-info'></i></div><div className='track-listing__contents'>{this.getContent()}</div></div>) : ''}
            {(tracks.length === 0 && visibleTracks.length === 0 && ((typeof this.state.pagination.current_page === 'undefined') || shouldRenderInitialPlaceholder)) ? <TrackBarebone locale={this.props.locale}/> : ''}
            {(tracks.length === 0 && visibleTracks.length === 0 && ((typeof this.state.pagination.current_page === 'undefined') || shouldRenderInitialPlaceholder)) ? <TrackBarebone locale={this.props.locale}/> : ''}
            {(tracks.length === 0 && visibleTracks.length === 0 && ((typeof this.state.pagination.current_page === 'undefined') || shouldRenderInitialPlaceholder)) ? <TrackBarebone locale={this.props.locale}/> : ''}
            {(tracks.length === 0 && visibleTracks.length === 0 && ((typeof this.state.pagination.current_page === 'undefined') || shouldRenderInitialPlaceholder)) ? <TrackBarebone locale={this.props.locale}/> : ''}
            {(tracks.length === 0 && visibleTracks.length === 0 && ((typeof this.state.pagination.current_page === 'undefined') || shouldRenderInitialPlaceholder)) ? <TrackBarebone locale={this.props.locale}/> : ''}
            {(tracks.length === 0 && visibleTracks.length === 0 && ((typeof this.state.pagination.current_page === 'undefined') || shouldRenderInitialPlaceholder)) ? <TrackBarebone locale={this.props.locale}/> : ''}
            {trackAndPanelNodes.length > 0 ? trackAndPanelNodes : (visibleTracks.length == 0 ? '' : this.noSongsAvailableText())}
            {spinner()}
            {smiley()}
            {pagination()}
          </div>
        )
      }
    }
  }
}

TrackListing.defaultProps = {
  showHeading: false,
  active_track_id: 0,
  show_pagination : true,
  composer_page_permalink: false,
  totalCount : 250,
  pricing_path: '',
  freeMode: false,
  hideAddToCart: false,
  exposurePackMode: false,
  exposurePackPreviewMode: false,
  i18n: {
    next: 'Next',
    previous: 'Previous',
    free: 'free',
    recently_created: 'new'
  },
  pagination: {
    current_page: 1,
    next_page: '',
    prev_page: '',
    total_pages: 1,
    total_count: 10
  },
  usageLicenseTypes : [],
  subscribedUsageLicenseTypes: [],
  content : [],
  show_download_button : false,
  hideItemIdList: false,
  hideTagLinks: false,
  trackShow: false,
  trackFavorites : [],
  tags: [],
  data : [],
  purchasedTrackIds: [],
  listingInsert: false,
  listingInsertIndex: 6,
  navigatorPanels: [],
  navigatorPanelInsertIndex: 6,
  licenseNavigatorPath: '/lizenz-navigator',
  gemaNavigatorPath: '/service/gema-navigator',
  gemaNavigatorTooltip: '',
  proScopeHintText: '',
  marketingCountLabel: '',
  initialNoFiltersActive: false,
  className: '',
  useAjaxPagination: false,
  showProScopeHint: true,
  showProTrackBadge: true,
  excludeTrackId: null,
  skipInitialPlayerInit: false
}


// INIT
let elements = document.querySelectorAll('[data-react-component=TrackListing]');

elements.forEach(function(element) {
  let reactProps = parseReactProps(element.dataset.reactProps);

  ReactDOM.render(
    <React.StrictMode>
      <TrackListing {...reactProps} />
    </React.StrictMode>,
    element
  );
})

export default TrackListing;
